import { toast } from 'alm-react-components';
import {
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  signInWithRedirect,
  signOut,
} from 'aws-amplify/auth';
import { createBrowserHistory } from "history";
import { t } from "i18next";
import MD5 from 'js-md5';
import { sha256 as SHA256 } from 'js-sha256';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import almTimeZone from '../assets/alm-timezones.json';
import { APPROUTES, BackendRespose, CognitoResponse, CurrencySymbol, FileNotation, NotificationChannel, PLIVETIME, SuperUsers, Tag, constants, corporateKeys } from '../assets/constants/constants';
import defaultBadge from '../assets/images/default-badge.png';
import defaultImg from '../assets/images/default-image-library.png';
import badge from '../assets/images/svgicons/notification/badge.svg';
import bell from '../assets/images/svgicons/notification/bell.svg';
import { AuthProvider } from '../interface';
import { apis } from '../services/alm';
import { DATA_CATION_URL } from '../services/urls';
import ClassOverviewVideo from './../assets/images/class-overview-video.png';
import DefaultCourse from './../assets/images/default-course.png';


const quaterWiseData = ['Q1', 'Q2', 'Q3', 'Q4'];
export const customHistory = createBrowserHistory();

export const currentUser = async () => {
  return await getCurrentUser();
};
export const authSession = async () => {
  /***payload
   * token :'some token'
   */
  return (await fetchAuthSession())?.tokens?.accessToken.toString();
};
export const userAttributes = async () => {
  /*** Payload User alleady login
   * token :'some token'
   */
  //----User alleadylogin in
  //-----first time login payload
  // {
  //     "sub": "a69d794e-fac5-48a7-8bcb-2279bee6768a",
  //     "identities": "[{\"userId\":\"108250698142639222037\",\"providerName\":\"Google\",\"providerType\":\"Google\",\"issuer\":null,\"primary\":true,\"dateCreated\":1710307125656}]",
  //     "email_verified": "false",
  //     "name": "test",
  //     "email": "some@harbingergroup.com"
  // }
  return await fetchUserAttributes();
};

export const socialLogin = async (type: AuthProvider) => {
  try {
    showLoader();
    await logOut();
    signInWithRedirect({provider: type})
      .then(() => {
        hideLoader();
      })
      .catch((e: any) => {
        hideLoader();
        console.log('error', e);
      });
  } catch (e: any) {
    console.log('error', e);
    hideLoader();
  }
};
export const logOut = async () =>
  await signOut()
    .then(res => {
      console.log('signOut------', res);
      sessionStorage.removeItem("lastActiveTimestamp");
      sessionStorage.removeItem("popupExpiryTimestamp");
    })
    .catch(error => {
      console.log('logOut-------', error);
    });
export const logOutFromCognito = () => {
  window.location.href = `https://${import.meta.env.VITE_APP_DOMAIN}/logout?client_id=${import.meta.env.VITE_APP_USER_POOL_CLIENT_ID}&logout_uri=${import.meta.env.VITE_SOCIAL_SIGNOUT_URL}`;
};

export const getDevice = () => {
  let OSName = 'Unknown OS';
  if (navigator.userAgent.indexOf('Win') != -1) OSName = 'Windows';
  else if (navigator.userAgent.indexOf('Mac') != -1) OSName = 'Macintosh';
  else if (navigator.userAgent.indexOf('Linux') != -1) OSName = 'Linux';
  else if (navigator.userAgent.indexOf('Android') != -1) OSName = 'Android';
  else if (navigator.userAgent.indexOf('like Mac') != -1) OSName = 'iOS';
  else{
    return 'no device'
  }
  return OSName;
};

export const getMessage = (type: string) => {
  let message = '';
  switch (type) {
    case 'PaymentFailure':
      message = 'payment failed';
      break;
    case 'UserNotFoundException':
      message = 'User does not exist.';
      break;
    default:
      message = '';
      break;
  }
  return message;
};

export const errorResponse = (type: string) => {
  let message = '';
  switch (type) {
    case 'PaymentFailure':
      message = 'payment failed';
      break;
    case 'UserNotFoundException':
      message = 'User does not exist.';
      break;
    default:
      message = '';
      break;
  }
  return message;
};

export const findGetParameter = (parameterName: string) => {
  let result = null,
    tmp = [];
  location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

export const showLoader = () => {
  document.getElementById('pdLoader')?.remove();
};

export const hideLoader = () => {
  document.getElementById('pdLoader')?.remove();
};

export const encrptText = (x: any) => {
  const o = MD5.md5.create();
  o.update(x);
  return o.hex();
};

export const md5 = (x: any) => {
  const o = MD5.md5.create();
  o.update(x);
  return o.base64();
};
export const sha256 = (x: any) => {
  const o = SHA256.create();
  o.update(x);
  return o.hex();
};
export const getCheckToken = () => {
  return localStorage.getItem('access_token') ? localStorage.getItem('access_token') : '';
};

//Learning program format date function made common
export function formatDate(dateString: any) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const date = new Date(dateString);
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  if(year && day && month ){

    return `${month} ${day} ${year}`;
  }else{
    return null
  }
}
export const weekIn = (
  key: number
): {
  name: string;
  image: string;
} => {
  switch (key) {
    case 0:
      return {name: 'readLearn', image: DefaultCourse};
      break;
    case 1:
      return {name: 'watchObserve', image: ClassOverviewVideo};
      break;
    case 2:
      return {name: 'exercise', image: DefaultCourse};
      break;
    case 3:
      return {name: 'liveMeetingRecording', image: ClassOverviewVideo};
      break;
    default:
      return {name: 'watchObserve', image: ClassOverviewVideo};
      break;
  }
};

export const cheekExpireDate = (date: any, numberOfDays = 7) => {
  if (date) {
    const startDate = new Date(date);
    startDate.setDate(startDate.getDate() + numberOfDays);
    // console.log('startDate---',startDate)
    const currentDate = new Date();
    return startDate <= currentDate;
  }
  return true;
};
export const hasWeekStart = (enrollmentDate: any, numberOfDays = 7) => {
  if (enrollmentDate) {
    const startDate = new Date(enrollmentDate);
    startDate.setDate(startDate.getDate() - numberOfDays);
    const currentDate = new Date();
    return startDate <= currentDate;
  }
  return false;
};
export const isProgramStart = (param: any, isFundamentalProgram = false) => {
  const enrollmentDate = param.enrollmentDate;
  const key = param.key;

  //convert quater start date and conver to date
  const currentQuarterDate: any = new Date(param.quarterStartDate as string);
  const currentDate: any = new Date();
  const birthday = moment(currentQuarterDate, 'DD-MM-YYYY');
  const currDay = moment(currentDate, 'DD-MM-YYYY');
  const diff = moment.duration(currDay.diff(birthday));
  const weeks = Math.floor(diff.asWeeks()) + 1;

  if (enrollmentDate && currentQuarterDate > new Date(enrollmentDate)) {
    return true;
  } else if (currentQuarterDate && isFundamentalProgram) {
    return key >= weeks ? false : true;
  } else if (currentQuarterDate && enrollmentDate) {
    return key >= weeks ? false : true;
  } else {
    return false;
  }
};

export const filterEnrollmentData = (apiResponseData: any, enrollmentId: string) => {
  const erollmentObj = apiResponseData?.included?.filter((val: any) => {
    return val.id == enrollmentId;
  })[0];
  let enrollmentData: any = null;
  if (erollmentObj) enrollmentData = erollmentObj.attributes;
  return enrollmentData;
};
export const formatEnrollmentDeadline = (enrollmentDeadline: any) => {
  const sevenDaysBefore = new Date(enrollmentDeadline);
  sevenDaysBefore.setDate(sevenDaysBefore.getDate() - 7); // Subtract 7 days
  const options: any = {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  return sevenDaysBefore.toLocaleString('en-US', options);
};
export const isEnrollmentProgramOpen = (quarterStartDate: any) => {

  let enrollmentOpen = false;
  const isEnrollmentDeadlineExpired = cheekExpireDate(quarterStartDate);
  if (quarterStartDate && !isEnrollmentDeadlineExpired) {
    enrollmentOpen = hasWeekStart(quarterStartDate, 14);
  }
  return enrollmentOpen;
};
export const getQuater = (months = new Date().getMonth()) => {
  let quater = '';
  switch (months) {
    case 0:
    case 1:
    case 2:
      quater = 'Q1';
      break;
    case 3:
    case 4:
    case 5:
      quater = 'Q2';
      break;
    case 6:
    case 7:
    case 8:
      quater = 'Q3';
      break;
    default:
      quater = 'Q4';
  }
  return quater;
};

export const getCurrentQuater = () => {
  return quaterWiseData.find(item => item === getQuater());
};
export const getQuaterTag = () => {};
const tagIndex = quaterWiseData.findIndex(item => item === getQuater());
export const currentYearData = quaterWiseData
  .slice(tagIndex)
  .map(qtr => ({qtr, year: new Date().getFullYear()}));
export const nextYearData = quaterWiseData
  .slice(0, tagIndex)
  .map(qtr => ({qtr, year: new Date().getFullYear() + 1}));
export const courseProgress = (programData: any, response: any) => {
  const weekSubLos = programData?.data?.relationships?.subLOs?.data;
  const learningProgramArray = [];
  for (let i = 0; i < weekSubLos?.length; i++) {
    const SubLosDetails = programData?.included?.find((ele: any) => ele.id == response[i].id);
    learningProgramArray.push(SubLosDetails);
  }
  const subLOsIdsArray = learningProgramArray.map(program => {
    return program?.relationships?.subLOs?.data.map((subLO: any) => subLO.id);
  });
  const flattenedSubLOsIds = subLOsIdsArray.flat();

  const courseArray = [];
  for (let i = 0; i < flattenedSubLOsIds?.length; i++) {
    const courseDetails = programData?.included?.find(
      (ele: any) => ele?.id == flattenedSubLOsIds[i]
    );
    courseArray.push(courseDetails);
  }

  const enrollmentIdsArray = courseArray?.map(
    course => course?.relationships?.enrollment?.data?.id
  );

  const enrollmentArray = [];
  for (let i = 0; i < enrollmentIdsArray?.length; i++) {
    const enrollmentIds = programData?.included?.find(
      (ele: any) => ele?.id == enrollmentIdsArray[i]
    );
    enrollmentArray.push(enrollmentIds);
  }

  const completedCourse = [];

  for (let i = 0; i < enrollmentArray?.length; i++) {
    if (enrollmentArray[i]?.attributes?.state === constants.COURSE_STATUS) {
      completedCourse.push(enrollmentArray[i].relationships.learningObject.data.id);
    }
  }
  return completedCourse;
};
export const duration = (dateCreated:any)=>{
  const dateNow :any= moment.utc();  
  const message :any=  moment.utc(dateCreated);  

  const minutes =dateNow.diff(message, 'minutes')
  const hours =dateNow.diff(message, 'hours')
  const days =dateNow.diff(message, 'days')
  if(days > 1){
      return `${moment(message).format('DD-MMM-YYYY | HH:MM')}`
  }else if(days === 1){
      return  t('Common.yesterday')
  }else{
      if(hours >= 1)
        return `${(hours.toFixed(0))} ${t('Common.hourAgo')}`;
      else if(minutes >= 10){
        return ` ${(minutes)}  ${t('Common.minAgo')}`
      }else{
          return t('Common.now')
    }
  }
};

export const sortName = (name: any) => {
  if (name) {
    const nameExpolode = name.split(/(\s+)/);
    const firstName: string = nameExpolode[0];
    const lastName = nameExpolode.length > 1 ? nameExpolode[nameExpolode.length] : ' ';
    return `${firstName[0].toUpperCase()} ${lastName && lastName.length > 1 ? lastName[0].toUpperCase() : ''}`;
  } else {
    return '';
  }
};

export const defaultImage = () => {
    return defaultImg;
};

export const limitOverview = (data: string, limit: number = 500) => {
  return data?.length > limit ? data.slice(0, 500) + ' ...' : data;
};
export const getInstructorInfo = (data: any) => {
  const weekSubLos = data?.data?.relationships?.subLOs?.data;
  const learningProgramArray = [];
  for (let i = 0; i < weekSubLos?.length; i++) {
    const SubLosDetails = data?.included?.find((ele: any) => ele.id == weekSubLos[i].id);
    learningProgramArray?.push(SubLosDetails);
  }
  const subLOsIdsArray = learningProgramArray?.map(program => {
    return program?.relationships?.subLOs?.data.map((subLO: any) => subLO.id);
  });
  const flattenedSubLOsIds = subLOsIdsArray?.flat();

  const courseArray = [];
  for (let i = 0; i < flattenedSubLOsIds?.length; i++) {
    const courseDetails = data?.included?.find((ele: any) => ele?.id == flattenedSubLOsIds[i]);
    courseArray.push(courseDetails);
  }
  const instancesArray = courseArray.map(course => {
    return course?.relationships?.instances?.data?.map((subLO: any) => subLO.id);
  });
  const instanceDetailsArray = [];
  const instancesIDs = instancesArray.flat();
  for (let i = 0; i < instancesIDs?.length; i++) {
    const instanceDetails = data?.included?.find((ele: any) => ele?.id == instancesIDs[i]);
    instanceDetailsArray?.push(instanceDetails);
  }
  const loResourcesArray = instanceDetailsArray?.map(instance => {
    return instance?.relationships?.loResources?.data?.map((subLO: any) => subLO.id);
  });
  const loResourceDetailsArray = [];
  const loResourceID = loResourcesArray.flat();
  for (let i = 0; i < loResourceID.length; i++) {
    const loResourceDetails = data?.included?.find((ele: any) => ele?.id == loResourceID[i]);
    loResourceDetailsArray.push(loResourceDetails);
  }
  const resourceDetailsArray = [];
  const resourceArray = loResourceDetailsArray?.map(instance => {
    return instance?.relationships?.resources?.data.map((subLO: any) => subLO.id);
  });
  const resourceID = resourceArray?.flat();
  for (let i = 0; i < resourceID.length; i++) {
    const resourceDetails = data?.included?.find((ele: any) => ele?.id == resourceID[i]);
    resourceDetailsArray.push(resourceDetails);
  }
  return resourceDetailsArray;
};

export const librarySearch = (keyword: string, data: any) => {
  const filterResult = data.filter((val: any) => {
    const englishName = val.attributes?.localizedMetadata?.[0]?.name
      ?.trim()
      .toLowerCase()
      ?.replace(/\s+/g, ' ');
      const dutchName = val.attributes?.localizedMetadata?.[1]?.name
      ?.trim()
      .toLowerCase()
      ?.replace(/\s+/g, ' ');
    const re = new RegExp(`\\b${keyword.toLowerCase()}\\b`, 'g');
    const englishDescription = val.attributes?.localizedMetadata?.[0]?.description?.trim().toLowerCase();
    const dutchDescription = val.attributes?.localizedMetadata?.[1]?.description?.trim().toLowerCase();
    const des = new RegExp(`${keyword.toLowerCase()}`, 'g');
    const englishOverview = val.attributes?.localizedMetadata?.[0]?.overview?.trim().toLowerCase();
    const dutchOverview = val.attributes?.localizedMetadata?.[1]?.overview?.trim().toLowerCase();
    const over = new RegExp(`${keyword.toLowerCase()}`, 'g');
    const englishLocale = val.attributes?.localizedMetadata?.[0]?.locale?.trim().toLowerCase();
    const dutchLocale = val.attributes?.localizedMetadata?.[1]?.locale?.trim().toLowerCase();

    const tags = val.attributes?.tags?.map((res: any) => {
      return res?.trim()?.toLowerCase();
    });
    return (
      englishName?.match(re) ||
      dutchName?.match(re) ||
      englishDescription?.match(des) ||
      dutchDescription?.match(des) ||
      englishOverview?.match(over) ||
      dutchOverview?.match(over) ||
      englishLocale?.match(re) ||
      dutchLocale?.match(re) ||
      tags?.forEach((res: any) => res.match(re))
    );
  });
  return filterResult;
};

export const createCurrentQuarterDetail = (currentQuarter: any, nextQuarter: any) => {
  const currentQuarterStartDate: any = new Date(currentQuarter.start as string);
  const nextQuarterStartDate: any = new Date(nextQuarter.start as string);

  const currentQuarterEnrollmentStartDate = moment(currentQuarterStartDate, 'DD-MM-YYYY').subtract(
    14,
    'days'
  );
  const currentQuarterEnrollmentEndDate = moment(currentQuarterStartDate, 'DD-MM-YYYY').add(
    6,
    'days'
  );

  const nextQuarterEnrollmentStartDate = moment(nextQuarterStartDate, 'DD-MM-YYYY').subtract(
    14,
    'days'
  );
  const nextQuarterEnrollmentEndDate = moment(nextQuarterStartDate, 'DD-MM-YYYY').add(6, 'days');

  const dateNow = moment().format(moment.HTML5_FMT.DATE);
  // console.log('dateNow-----', dateNow);
  let detail = {
    showEnrollment: false,
    showQuaterProgramFor: currentQuarter,
    prevQuater: null,
    ...currentQuarter,
  };

  if (moment(dateNow).isBetween( currentQuarterEnrollmentStartDate.format(moment.HTML5_FMT.DATE), 
        currentQuarterEnrollmentEndDate.format(moment.HTML5_FMT.DATE), undefined, '[]' ) ) {
    detail = {
      showEnrollment: true,
      isEnrollmentOpen:true,
      showQuaterProgramFor: currentQuarter,
      prevQuater: null,
      ...currentQuarter,
      text: 'between currentQuarter',
    };
  } else if (
    moment(dateNow).isBetween(
      nextQuarterEnrollmentStartDate.format(moment.HTML5_FMT.DATE),
      nextQuarterEnrollmentEndDate.format(moment.HTML5_FMT.DATE),
      undefined,
      '[]'
    )
  ) {
    detail = {
      showEnrollment: true,
      isEnrollmentOpen:true,
      showQuaterProgramFor: nextQuarter,
      prevQuater: currentQuarter,
      ...nextQuarter,
      text: 'between nextQuarter',
    };
  } else if (
    moment(dateNow).isBetween(
      moment(currentQuarterStartDate, 'DD-MM-YYYY').add(7, 'days').format(moment.HTML5_FMT.DATE),
      moment(nextQuarterStartDate, 'DD-MM-YYYY').subtract(15, 'days'),
      undefined,
      '[]'
    )
  ) {
    detail = {
      showEnrollment: false,
      isEnrollmentOpen:false,
      showQuaterProgramFor: nextQuarter,
      prevQuater: currentQuarter,
      ...nextQuarter,
      text: 'after current quarter 7 days',
    };
  }
  return detail; // { cr:quarter,   cr:quarter, };
};

export const getBadgeDetail = (badgeData: any, instancesId: any) => {
  const badgeArr = badgeData.included.filter((badgeItem: any) => instancesId === badgeItem.id);
  const badgeDataId = badgeArr[0].relationships?.badge?.data.id;
  const detail = badgeData.included.filter((badgeItem: any) => badgeItem?.id === badgeDataId);
  return detail[0]?.attributes;
};
export const PodcastTags: any = [
  'New Podcasts',
  'Inner Stance Podcasts',
  'Straight-Line Podcasts',
  'Special Podcasts',
];
export const searchedItems = [
  constants.VIDEOS,
  constants.DOCUMENTS,
  constants.PODCAST,
  constants.BOOKS,
  constants.BULLETINS,
];
export const bookMarkData=[constants.VIDEOS, constants.RECOMMENDED, constants.BULLETINS,constants.DOCUMENTS,constants.BOOKS,constants.PODCAST,constants.DOCUMENT,constants.MEETING,constants.EXERCISE,Tag.liveclass,constants.relatedContent]

export const dailyReminderLimit = (data: string, limit: number = 100) => {
  return data?.length > limit ? data.slice(0, 500) + ' ...' : data;
};

export const seeAllProgramSection = (enrolledData: []) => {
  return enrolledData.filter(
    (res: any) => !res?.attributes?.tags?.includes(constants.MYSTANCE_FUNDAMENTAL_PROGRAM)
  );
};

export const isEnrollmentDateAvailable = (date: any) => {
  if (!date) return false;
  const beforeStartDate = moment(date).subtract(14, 'days').startOf('day');
  const afterStartDate = moment(date).add(6, 'days').endOf('day');
  const now = moment();
  return now.isSameOrAfter(beforeStartDate) && now.isSameOrBefore(afterStartDate);
};

export const date = new Date().toISOString().slice(0, 10);
export const almZoneId = () => {
  const zoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const codeForTimeZone = almTimeZone?.timeZone.filter((res: any) => {
    return res?.zoneId === zoneId;
  })[0]?.zoneId;
  return codeForTimeZone;
};

export const copyToClipboard = (ref: any, toastMsg: any) => {
  const h2Text = ref.textContent;
  navigator.clipboard
    .writeText(h2Text)
    .then(() => {
      toastMsg();
    })
    .catch(err => {
      console.error('Failed to copy text: ', err);
    });
};

export const mainProgramWeekEnable =(programStartDate:any, key=0)=>{
  const eachWeekDate: any = moment(programStartDate).add(key*7,'days').utc().toDate();
  const currentUTCtime = moment.utc().toDate();
  // console.log('eachWeekDate',moment(eachWeekDate).format('YYYYMMDD HH:mm:ss A'))
  // console.log('currentUTCtime',moment(currentUTCtime).format('YYYYMMDD HH:mm:ss A'))
  const isEnabled = moment(eachWeekDate).isSameOrBefore((currentUTCtime));
  return isEnabled;
}

export const checkWeekStatus = (startDate: any) => {
  if (startDate) {
    const date = moment();
    const weekStartDate = moment(startDate);
    const weekEndDate = moment(weekStartDate).add(7, 'days');

    // Check if the current time is before 5 PM on the start date
    const weekUnlockDateTime = moment(weekStartDate).format("YYYY-MM-DD") + " " + PLIVETIME;
    const unlockMomentDateTime = moment(weekUnlockDateTime,"YYYY-MM-DD HH:mm:ss");

    // If the current date is the start date but before 5 PM, consider it as UPCOMING
    if (
      date.format("YYYY-MM-DD") === weekStartDate.format("YYYY-MM-DD") &&
      date.isBefore(unlockMomentDateTime)
    ) {
      return constants.UPCOMING;
    }

    if (date.isBetween(weekStartDate, weekEndDate, null, '[]')) {
      return constants.LIVE;
    } else if (weekEndDate.isBefore(date)) {
      return constants.PAST;
    } else {
      return constants.UPCOMING;
    }
  } else {
    return;
  }
};
export const covertDateUtcToIST = (utcDate: string | undefined, timeZone: string | undefined) => {
  const zoneId = getDefaultTimezone(timeZone);
  const utcCutoff = moment.utc(utcDate, 'YYYYMMDD HH:mm:ss');
  const displayCutoff = utcCutoff?.clone().tz(zoneId);
  return displayCutoff;
};
export const getDefaultTimezone=(timeZone: string | undefined)=>{
  const codeForTimeZone = almTimeZone?.timeZone.filter((res: any) => {
    return res.id === timeZone || res.zoneId === Intl.DateTimeFormat().resolvedOptions().timeZone;
  })[0]?.zoneId;
  return codeForTimeZone
}

export const badgeUrl = (id: any, included: any) => {
  let badgeId = '';
  let imageUrl = '';
  if (included) {
    const fattenArray = included.flat(1);
    for (let i = 0; i < fattenArray?.length; i++) {
      if (fattenArray[i]?.id === id) {
        badgeId = fattenArray[i]?.relationships?.badge?.data?.id;
      }
    }
    if (badgeId) {
      for (let i = 0; i < fattenArray?.length; i++) {
        if (fattenArray[i]?.id === badgeId) {
          imageUrl = fattenArray[i]?.attributes?.imageUrl;
        }
      }
    }
    if (imageUrl) {
      return imageUrl;
    }
    else{
      return defaultBadge;
    }
  }
};
export const getCurrencySymbol = (type: string) => {
  return CurrencySymbol[type];
};

export const highLight = (
  tag: any,
  currentQuater: string,
  getQuaterStartData: (id: string,val:any) => void
) => {
  const res: any = getQuaterStartData(tag?.quarter,tag?.year);
  if (res?.quarter === currentQuater && +res?.year === new Date().getFullYear()) {
    return true;
  } else {
    return false;
  }
};
export const checkLottie = (name: string) => {
  const file = name;
  return file.includes(FileNotation.lottie); //|| file.includes('lottie')
};

export const textCapatilize = (displayName: any) => {
  return displayName.charAt(0).toUpperCase() + displayName.slice(1);
};

export const weekCount = (apiData: any) => {
  let weekCount = 0;
  apiData?.data[0]?.relationships?.subLOs?.data?.forEach((element: any) => {
    const LPDetails = apiData?.included?.find(
      (ele: any) => ele.id == element?.id
    );
    const doNotShowWeek = apiData?.included?.find(
      (ele: any) => ele?.id === LPDetails?.id
    );
    // List of tags to exclude (introduction videos and "do not show")
    const excludedTags = [Tag.introductionVideo, Tag.doNotShow ,Tag.overviewIntroVideo];
    if (
      !doNotShowWeek?.attributes?.tags?.some((tag: any) =>
        excludedTags.includes(tag)
      )
    ) {
      weekCount += 1;
    }
  });
  return weekCount;
};

export const weekCountWithOutDoNotShowProgram = (cardInfo: any) => {
  let weekCount = 0;
  cardInfo?.relationships?.subLOs?.data?.forEach((element: any) => {
    const ids = element.id.split(':');
    if (ids[0] !== constants.course) {
      weekCount += 1;
    }
  });
  return weekCount;
};

export const clearLocalStorage = (sessionExpire?:string) => {
  
  if (sessionExpire) {
    toast({
      description: t("Validations.sessionExpire"),
      variant: 'error',
    });
  }
  //
  // Clear all local storage except for i18nextLng and locale keys.
  // This is to ensure that the language selection remains persistent across page refreshes.
  
  if (localStorage.length) {
    for (const [key] of Object.entries(localStorage)) {
      if (!['i18nextLng', 'locale'].includes(key)) {
        localStorage.removeItem(key);
      }
    }
  }
};

export const removeExitingSession = () => {
  logOut();
  clearLocalStorage();
};

export const getNotificationIcon=(channel:string)=>{
  switch (channel) {
    case NotificationChannel.learningProgramCompleted:
      return badge
    case NotificationChannel.courseCompleted:
        return badge
    default:
      return bell
  }
}
export const getNexturlData=async(res:any)=>{
  const arr=[]
  arr.push(res.data); 
  let isTrue = res?.links?.next;
  while (isTrue) {
    const result: any = await apis.nextBaseUrl(isTrue);
    arr.push(result.data);
    isTrue = result?.links?.next ? result?.links?.next : false;
  }
  return arr.flat()
}

/**
 * Checks if a given date is within the range of start and end dates.
 *
 * @param dateToCheck - The date to verify (Date object).
 * @param startDate - The start date of the range (ISO string or valid date string).
 * @param endDate - The end date of the range (ISO string or valid date string).
 * @returns True if the dateToCheck is within the range; otherwise, false.
 */


export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

// Function to check if a date is within a given range
export const isDateInRange = (
  startDate: string | Date | null | undefined,
  endDate: string | Date | null | undefined,
  targetDate: string | Date | null | undefined
): boolean => {
  if (!startDate || !endDate || !targetDate) {
    return false;
  }

  const start = new Date(startDate);
  const end = new Date(new Date(endDate).getTime() - ONE_DAY_IN_MILLISECONDS);
  const target = new Date(targetDate);

  return target >= start && target <= end;
};

export const LibraryFilteration = (
  tagsData: any,
  sectionData: any,
  sectionTag?: any,
  podcastTag1?: any,
  podcastTag2?: any,
  podcastTag3?: any
) => {
  if (tagsData?.length) {
    const data = sectionData?.filter((item: any) => {
      return tagsData.some((res: any) => {
        return (
          item?.attributes?.tags?.includes(
            res?.attributes?.localizedMetadata[0]?.name
          ) ||
          item?.attributes?.tags?.includes(sectionTag) ||
          item?.attributes?.tags?.includes(podcastTag1) ||
          item?.attributes?.tags?.includes(podcastTag2) ||
          item?.attributes?.tags?.includes(podcastTag3) ||
          !item?.attributes?.tags
        );
      });
    });
    return data;
  } else {
    const data = sectionData?.filter((item: any) => {
      return (
        item?.attributes?.tags?.includes(sectionTag) || !item?.attributes?.tags
      );
    });
    return data;
  }
};

export const  compareByWeek=(a:any, b:any)=> {
  const regex = /\s*week\s*(\d+)\s*/i;
  const matchA = a?.attributes?.localizedMetadata[0]?.name.match(regex);
  const matchB = b?.attributes?.localizedMetadata[0]?.name.match(regex);
  const weekA = matchA ? parseInt(matchA[1], 10) : 0;
  const weekB = matchB ? parseInt(matchB[1], 10) : 0;
    return weekA - weekB;
}

export const ignoreErrorForApi=(url:string)=>{
  return url.indexOf(DATA_CATION_URL) !== -1;
}
export const headerLogUrl=()=>{
  const url =localStorage.getItem('access_token') ? APPROUTES.home :'/';
  return url;
}

export const awsErrorCodeMsgToster=(key:string,islogin:boolean)=>{
  let text=''
  switch(key){
    case CognitoResponse.userNotFoundException:
      text= islogin ? t('Common.userNotExist') : t('ErrorType.invalidRequest');
    break;
    case CognitoResponse.notAuthorizedException || CognitoResponse.userNotFoundException:
      text= islogin ? t('Common.userNotExist') : t('ErrorType.invalidRequest');
    break;
    case CognitoResponse.codeMismatchException:
      text=t('Validations.invalidVerification');
    break;
    case CognitoResponse.signInException:
      text=t('ErrorType.invalidRequest');
    break;
    default:
      text=t('ErrorType.invalidRequest')
    break;
  }
  //Toaster message 
  toast({
    description: text,
    variant: 'error',
  });
}
export const awsErrorCodeMsgTosterOnLogin=(key:string)=>{
  let text=''
  switch(key){
    case CognitoResponse.error.userNotExist:
      text= t('Common.userNotExist');
    break;
    case CognitoResponse.error.attemptLimitExceeded:
      text= t('Validations.attemptLimitExceeded');
    break;
    default:
      text=t('Validations.temporaryPasswordExpired')
    break;
  }
  //Toaster message 
  toast({
    description: text,
    variant: 'error',
  });
}
export const errorTosterCodeMsg=(key:string)=>{
  let text=''
  switch(key){
    case BackendRespose.subscriptionExpired: 
      text=t('Common.subscriptionExpired');
    break;
    case BackendRespose.accountDeletedMessage:
      text=t('Common.accountDeletedMessage');
    break;
    case BackendRespose.accountDeactivatedMessage:
      text=t('Common.accountDeactivatedMessage');
    break;
    case BackendRespose.userNotFoundError:
      text=t('Validations.userNotFoundError');
    break;
    default:
      text=t('ErrorType.invalidRequest')
    break;
  }
  //Toaster message 
  toast({
    description: text,
    variant: 'error',
  });
}
export const getPodcasts = (): any[] => {
  const { t } =useTranslation();
  return [
    {
      label:t("Program.podcastSection.newPodcasts"), 
      tagName: t("Program.podcastSectionTags.newPodcasts"), 
    },
    {
      label:t("Program.podcastSection.innerSTancePodcasts"),
      tagName:t("Program.podcastSectionTags.innerSTancePodcasts"),
    },
    {
      label:t("Program.podcastSection.straightLinePodcasts"),
      tagName:t("Program.podcastSectionTags.straightLinePodcasts"),
    },
    {
      label:t("Program.podcastSection.specialPodcasts"),
      tagName:t("Program.podcastSectionTags.specialPodcasts"),
    },   
  ];
};


export const backendErrorCodeMsgToster=(key:string)=>{
  let text=''
  switch(key){
  case BackendRespose.notAuthorizedException:
    text=t('Common.userNotExist');
  break;
  case BackendRespose.unknownErrorOccured:
    text=t('Common.invalidRequest');
  break;
  default:
    text=t('ErrorType.invalidRequest')
  }
  //Toaster message 
  toast({
    description: text,
    variant: 'error',
  });
}

export const logClick=()=>{
  window.scroll(0, 0);
}

export const canProgramBeUnenrolled = (currQuarterStartDate: string,nextQuarterStartDate: string, programEnrollDate: string
) => {
  const currentQuarterEnrollmentStartDate = moment(currQuarterStartDate, 'YYYY-MM-DD').subtract(14, 'days').startOf('day');
  const currentQuarterEnrollmentEndDate = moment(currQuarterStartDate, 'YYYY-MM-DD').add(6, 'days').endOf('day'); 

  const nextQuarterEnrollmentStartDate = moment(nextQuarterStartDate, 'YYYY-MM-DD').subtract(14, 'days').startOf('day');
  const nextQuarterEnrollmentEndDate = moment(nextQuarterStartDate, 'YYYY-MM-DD').add(6, 'days').endOf('day'); // Include the whole day

  const enrollDate = moment(programEnrollDate).startOf('day');
  return (
    enrollDate.isBetween(currentQuarterEnrollmentStartDate, currentQuarterEnrollmentEndDate, undefined, '[]') ||
    enrollDate.isBetween(nextQuarterEnrollmentStartDate, nextQuarterEnrollmentEndDate, undefined, '[]')
  );
};


export const getRedirectPaths = (location: any, path: string) => {
  let redirectPaths = localStorage.getItem('redirectPaths') ? JSON.parse(localStorage.getItem('redirectPaths') || '') : [];
  const currentLocation = `${location?.pathname}${location?.search}`;

  if(!currentLocation.includes(path)) {
    if(!redirectPaths?.includes(currentLocation) && !redirectPaths?.includes(`/${path}`)) {
      redirectPaths.push(currentLocation);
    } else {
      redirectPaths = redirectPaths.filter((rp: any) => !rp.includes(currentLocation) && !rp.includes(path));
      redirectPaths.push(currentLocation);
    } 
  }

  return redirectPaths;
}

export const getCorporateAccountFlag=(dbValue:number|null|undefined)=>{
  return dbValue === 1 ? true: dbValue === 0 ? false : false
}

export const checkCorporateAccountUser=(roles:string[]|null|undefined)=>{
  return roles && roles.length  ? true :false
}
export const checkCorporateAdminAcount=(sllCorporateAccountRoles:string[]|null|undefined)=>{
  return sllCorporateAccountRoles?.includes(corporateKeys.CORPORATE_OWNER) || sllCorporateAccountRoles?.includes(corporateKeys.CORPORATE_ADMIN) 
}
export const allStorage=()=> {

  const archive:any = {}; // Notice change here
  const keys = Object.keys(localStorage);
  let i = keys.length;

  while ( i-- ) {
      archive[ keys[i] ] = localStorage.getItem( keys[i] );
  }

  return archive;
}
export const checkSuperUsers=(roles:string[])=>{
  return   roles.some(r=> SuperUsers.includes(r))  ? true : false
}
export const checkCurrentDate=(serverDate:string)=>{
  const dateObj = new Date(serverDate);
  return  moment(dateObj).isSame(moment(), 'day')
}

 /**
 * Format time in milliseconds to a human-readable format (e.g., "14m 59s")
 * @param milliseconds - Time in milliseconds
 * @returns Formatted time string in "Xm Ys" format
 */
export const formatTimeRemaining = (milliseconds: number): string => {
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds}s`;
};
export const getSlectedLanguge:any =()=>{
  return localStorage.getItem('locale') 
}

// generates the random string

export const generateRandomString = (length = 8) => { // Default length to 8, you can adjust
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters[randomIndex];
  }

  return randomString;
};

export const cleanHtmlSpaces = (htmlString:any) => {
  return htmlString.replace(/&nbsp;/g, ' ');
};

export const removeChainlitPopup =()=>{
  const elementsToRemove = [
        '[id^="chainlit"]',
        '[class*="chainlit"]',
        'iframe[src*="chainlit"]'
      ];
  
  elementsToRemove.forEach(selector => {
    try {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        elements.forEach(element => element.remove());
      }
    } catch (error:any) {
      console.log(error)
    }
  });
}
export const isOpenChainlit=()=>{
  const shadowRootElem = document.querySelector('#chainlit-copilot')?.shadowRoot
  const elementBtn=shadowRootElem?.querySelector('#cl-shadow-root')?.querySelector('button')
  const dataState=elementBtn?.getAttribute('data-state')
  return dataState === 'open' ? true :false
}